import $ from 'jquery';
import {is_function} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';

// --------------- //
// UI - ButtonMenu //
// --------------- //
LP.UI.ButtonMenu = {
  init: function (params) {
    $(params.group, params.selector)
      .click(function () {
        var $this = $(this);

        if (is_function(params.click) && !params.click($this)) return false;
        LP.UI.ButtonMenu.activate(params.group, this);
        return false;
      })
      .bind({
        mouseover: function () {
          var $this = $(this);
          if ($this.hasClass('ui-state-active')) {
            $this.bind('mouseleave', LP.UI.ButtonMenu.mouseLeaveButtonsetHandler);
          }
        },
      });
  },

  activate: function (group, button, skipActivation) {
    $(group).removeClass('active ui-state-active lp-ui-state-active').unbind('mouseleave', LP.UI.ButtonMenu.mouseLeaveButtonsetHandler);
    if (!skipActivation) $(button).blur().addClass('active ui-state-active lp-ui-state-active').bind('mouseleave', LP.UI.ButtonMenu.mouseLeaveButtonsetHandler);
  },

  mouseLeaveButtonsetHandler: function () {
    $(this).addClass('ui-state-active');
  },
};
